import { TimelineMax, Elastic, Power3 } from 'gsap';
import { random } from 'lodash';
import { layout } from '@/scripts/layout';
import u from '@/scripts/utils';

const FlowerAtach = (flower, stone) => {
  const cursor = document.querySelector('.cursor-ball');

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .to(cursor, 0.1, {
      scale: 0,
      ease: Power3.easeOut,
    }, 'start')
    .to(cursor, 0.6, {
      scale: 1,
      ease: Elastic.easeOut,
    }, '-=0.05')
    .to(flower.scale, 0.8, {
      x: (u.isTouchDevice() ? 1 : 0.5) * layout.viewport.ratio.width,
      y: (u.isTouchDevice() ? 1 : 0.5) * layout.viewport.ratio.width,
      ease: Elastic.easeOut,
    }, 'start')
    .to(flower.position, 4, {
      x: stone.position.x + random(0, stone.width),
      y: stone.position.y + random(0, stone.height),
      ease: Power3.easeInOut,
    }, 'start')
    .to(flower, 4, {
      angle: random(-90, 90),
      ease: Power3.easeInOut,
    }, 'start');
  return tl;
};

export default FlowerAtach;
